/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react'
import {
  FormControl,
  InputLabel,
  Input,
  Button,
  Typography,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Select,
  MenuItem,
  Paper,
  Snackbar,
  Alert,
  Box,
} from '@mui/material'
import { useMutation, useQuery } from '@apollo/client'
import { useNavigate, useParams } from 'react-router-dom'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import mimeTypes from 'mime'
import _get from 'lodash/get'

// import { Main } from '@oclif/command'
import eventByIdQuery from '../../graphql/query/eventById'
import checkedBibMutation from '../../graphql/mutation/checkedBib'
import Breadcrumb from '../../components/BreadcrumbLayout'
import axios from 'axios'

const CreateParticipantPage = () => {
  const params = useParams()
  const [bib, setBib] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [birthDate, setBirthDate] = useState('')
  const [gender, setGender] = useState('')
  const [ageCategory, setAgeCategory] = useState('')
  const [row, setRow] = useState('')
  const [nationality, setNationality] = useState('')
  const [nationalId, setnNationalId] = useState('')
  const [shirtSize, setShirtSize] = useState('')
  const [shirtType, setShirtType] = useState('')
  const [ticketCode, setTicketCode] = useState('')
  const [ticketType, setTicketType] = useState('')

  // const [logo, setLogo] = useState('')
  const [file, setFile] = useState('')
  const [fileImg, setFileImg] = useState('')
  const [open, setOpen] = useState(false)
  const [openSnack, setOpenSnack] = useState(false)
  const navigate = useNavigate()
  const { data } = useQuery(eventByIdQuery, {
    variables: {
      _id: params.eventId,
    },
  })
  const reader = new FileReader()
  const handleClose = () => {
    setOpen(false)
    navigate(`/event/${params.eventId}/participant`)
    window.location.reload()
  }
  const [checkedBib] = useMutation(checkedBibMutation)
  console.log(params, 'params')
  const handleSubmit = async (e) => {
    e.preventDefault()

    const record = {
      bib: `${bib}`,
      firstname: firstName,
      lastname: lastName,
      displayName: displayName,
      birthDate: birthDate,
      ...(_get(data, 'eventId.isFaceCheckin') && {
        photo: file,
      }),
      gender: gender,
      ageCategory: ageCategory,
      row: row,
      nationality: nationality,
      nationalId: `${nationalId}`,
      shirt: { size: shirtSize, type: shirtType },
      // Always send `options` — the mobile app dereferences it without a
      // null check, and it reads the birth date out of there.
      options: {
        ...(ticketCode && { ticketCode }),
        ...(ticketType && { ticketType }),
        ...(birthDate && { birthDate }),
      },
      eventId: params.eventId,
    }
    console.log(record, 'rec')
    await checkedBib({
      variables: {
        filter: record,
      },
    })
      .then((res) => {
        if (res.data.checkedBib === null) {
          setOpenSnack(true)
        } else {
          setOpen(true)
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
  const selectFile = async (e) => {
    e.preventDefault()
    const tempFile = e.currentTarget.files[0]
    setFileImg(tempFile)
    reader.readAsDataURL(tempFile)
    reader.onload = async (event) => {
      const extType = mimeTypes.getExtension(tempFile.type)
      const ext = mimeTypes.getType(extType)
      const response = await fetch(process.env.REACT_APP_UPLOAD_SERVER, {
        method: 'POST',
        body: JSON.stringify({
          ext: `${ext}`,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      const result = await response.json()
      await axios.put(result.uploadUri, tempFile, {
        headers: {
          'Content-Type': `${ext}`,
          'x-goog-acl': 'public-read',
        },
      })
      setFile(result.downloadUri)
    }
  }
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }

  function AlertComponent(props) {
    return <Alert elevation={6} variant="filled" {...props} />
  }

  const genderList = ['male', 'female']
  return (
    <React.Fragment>
      <Breadcrumb path="/events" titleLink="Event" titleTypo="Create Participant" />
      <br />
      <Grid
        sx={{
          width: 'auto',
          mx: 2,
          [(theme) => theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 600,
            mx: 'auto',
          },
        }}>
        <Paper
          sx={{
            mt: { xs: 3, sm: 6 },
            mb: { xs: 3, sm: 6 },
            p: { xs: 2, sm: 3 },
          }}>
          <form onSubmit={handleSubmit}>
            <Typography
              style={{ marginTop: '20px', marginBottom: '20px' }}
              variant="h4"
              gutterBottom>
              Create Participant
            </Typography>
            <Grid item xs={12} sm={6}>
              <Typography style={{ marginTop: '20px' }} variant="h6" gutterBottom>
                Detail
              </Typography>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel htmlFor="eventName">Bib</InputLabel>
                  <Input autoFocus id="bib" name="bib" onChange={(e) => setBib(e.target.value)} />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel htmlFor="eventName">First Name</InputLabel>
                  <Input
                    autoFocus
                    id="firstName"
                    name="firstName"
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel htmlFor="eventName">Last Name</InputLabel>
                  <Input
                    id="lastName"
                    name="lastName"
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel>Display Name</InputLabel>
                  <Input
                    autoFocus
                    id="displayName"
                    name="displayName"
                    onChange={(e) => setDisplayName(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel>Birth Date</InputLabel>
                  <Input
                    autoFocus
                    id="birthdate"
                    name="birthdate"
                    onChange={(e) => setBirthDate(e.target.value)}
                  />
                </FormControl>
              </Grid>
              {_get(data, 'eventId.isFaceCheckin') && (
                <Grid item xs={12}>
                  <FormControl margin="normal" fullWidth required>
                    <InputLabel>Photo</InputLabel>
                    <Button
                      variant="contained"
                      size="small"
                      component="label"
                      sx={{ mt: 2.5, ml: 50, width: '120px' }}
                      startIcon={<CloudUploadIcon />}>
                      {fileImg.name ? fileImg.name : 'Choose Image'}
                      <input
                        onChange={selectFile}
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="contained-button-file"
                        type="file"
                      />
                    </Button>
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    select
                    style={{ width: '200px' }}
                    id="gender"
                    name="gender"
                    // value={state.gender}
                    onChange={(e) => setGender(e.target.value)}
                    inputProps={{
                      name: 'role',
                      id: 'role-helper',
                    }}>
                    {genderList.map((row) => (
                      <MenuItem value={row} key={row}>
                        {row}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" required>
                  <InputLabel>Age Category</InputLabel>
                  <Input
                    autoFocus
                    id="ageCategory"
                    name="ageCategory"
                    onChange={(e) => setAgeCategory(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" required>
                  <InputLabel>Row</InputLabel>
                  <Input autoFocus id="row" name="row" onChange={(e) => setRow(e.target.value)} />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" required>
                  <InputLabel>Nationality</InputLabel>
                  <Input
                    autoFocus
                    id="nationality"
                    name="nationality"
                    onChange={(e) => setNationality(e.target.value)}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" required>
                  <InputLabel>National ID</InputLabel>
                  <Input
                    autoFocus
                    id="nationalId"
                    name="nationalId"
                    onChange={(e) => setnNationalId(e.target.value)}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Typography
              style={{ marginTop: '20px', marginBottom: '10px' }}
              variant="h6"
              gutterBottom>
              Shirt Detail
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel>Shirt Size</InputLabel>
                  <Input
                    autoFocus
                    id="shirtSize"
                    name="shirtSize"
                    onChange={(e) => setShirtSize(e.target.value)}
                    // value={slugShirt}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel>Type Shirt</InputLabel>
                  <Input
                    autoFocus
                    id="shirtType"
                    name="shirtType"
                    onChange={(e) => setShirtType(e.target.value)}
                    // value={typeShirt}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Typography
              style={{ marginTop: '20px', marginBottom: '10px' }}
              variant="h6"
              gutterBottom>
              Ticket
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl
                  margin="normal"
                  fullWidth
                  required={_get(data, 'eventId.options.search.qrcode')}>
                  <InputLabel>Ticket Code</InputLabel>
                  <Input
                    autoFocus
                    id="ticketCode"
                    name="ticketCode"
                    onChange={(e) => setTicketCode(e.target.value)}
                    // value={ticketType}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl margin="normal" fullWidth required>
                  <InputLabel>Ticket Type</InputLabel>
                  <Input
                    autoFocus
                    id="ticketType"
                    name="ticketType"
                    onChange={(e) => setTicketType(e.target.value)}
                    // value={ticketType}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                sx={{ mt: 2.5, mb: 2.5, mt: 3, ml: 1 }}
                type="submit"
                variant="contained"
                color="primary">
                Submit
              </Button>
            </Box>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description">
              <DialogTitle id="alert-dialog-title">Participant Created</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Participant has been created.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
            <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
              <Alert onClose={handleCloseSnack} severity="error" sx={{ width: '100%' }}>
                Bib is already!
              </Alert>
            </Snackbar>
          </form>
        </Paper>
      </Grid>
    </React.Fragment>
  )
}

export default CreateParticipantPage
